import React from 'react';
import { Base64 } from 'js-base64';
import { useParams } from 'react-router-dom';
import EventRolloutGate from '../../../SocialGalleryV2/EventRolloutGate';
import EventGallery from './EventGallery';
import LegacyGallery from './LegacyGallery';

export default function GalleryEntry() {
  const { id } = useParams();
  let eventId = '';
  try { eventId = Base64.atob(id); } catch (_) { /* Invalid links fail closed. */ }
  return <EventRolloutGate eventId={eventId} pilot={EventGallery} legacy={LegacyGallery} />;
}
